module.exports = __webpack_public_path__ + "img/d4.3e5186c1.png";